
import { getMerchant } from '@/api/merchant/merchant'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { productAccountBasicRules } from '@/utils/rules'
import { Form as ElForm } from 'element-ui'
import {
  dedicatedMerchantAccount,
  getProductAccount
} from '@/api/product/productAccount'
import { operationMessage } from '@/utils/message'

@Component({
  name: 'dedicatedMerchant',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) product!: any
  @Prop({ required: true }) id!: string | number

  private infoForm: any = {
    merchant_no: null,
    description: null
  }
  private dedicatedMerchant: any = {}
  private merchantList: any[] = []
  private rules = productAccountBasicRules
  private radio: boolean = false
  private loading: boolean = false
  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back() {
    this.$emit('close')
    this.infoForm.description = ''
  }

  // 点击清空商户号
  private emptyMerchant(e) {
    if (e) {
      this.infoForm.merchant_no = null
    }
  }

  // 获取商户列表
  private async getMerchantList(isFilter?: boolean) {
    const data: any = {
      page: 1,
      page_size: 100
    }
    await getMerchant(data).then((res: any) => {
      if (isFilter) {
        this.merchantList = res.results.filter((item: any) => {
          return item.merchant_no !== this.infoForm.merchant_no
        })
      } else {
        this.merchantList = res.results
      }
    })
  }

  // 远程查询
  private async remoteQuery1(query: string) {
    const data = {
      name: query,
      product: this.product.id
    }
    await getMerchant(data).then((res: any) => {
      this.merchantList = res.results.filter((item: any) => {
        return item.merchant_no !== this.infoForm.merchant_no
      })
    })
  }

  private async getProductAccount() {
    await getProductAccount(this.id).then((res: any) => {
      if (res.merchant_dedicated_product_account) {
        this.infoForm = res.merchant_dedicated_product_account
      }
    })
  }

  private confirm() {
    ;(this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true
          this.flag = true
          const data: any = {
            id: this.id,
            merchant_no: this.infoForm.merchant_no,
            description: this.infoForm.description
          }
          await dedicatedMerchantAccount(data).then((res: any) => {
            operationMessage(true)
            this.loading = false
            this.flagStr()
            this.back()
            this.radio = false
          })
        } catch (e) {
          this.flagStr()
          this.loading = false
        }
      } else {
        return false
      }
    })
  }

  mounted() {
    this.getMerchantList()
    this.getProductAccount()
  }
}
